module.exports = __webpack_public_path__ + "img/imgeditbt.ff983bdf.png";